module.exports = __webpack_public_path__ + "static/media/speed.b6d43849.png";